import "./CircularProgress.scss";
import { memo } from "react";

export default memo(function CircularProgress({ size = "m", colour, className = "", ...props }) {

    const displayProps = {
        ...props,
        className: [
            'CircularProgress',
            size && 'CircularProgressSize--' + size,
            colour && 'CircularProgressColour--' + colour,
            className
        ].filter(x => x).join(" "),
    };

    return (
        <svg {...displayProps} viewBox="25 25 50 50">
            <circle className="CircularProgress__circle" cx="50" cy="50" r="20" fill="none"></circle>
        </svg>
    )
});